import {ListItem} from "@domain/common/list-view/list-item";

export class Lien {
    libelle?: string;
    url?: string;
    // remarque?: string;
}

/**
 * Modèle de paramétrage de la boite lien
 */
export class BoiteLien implements ListItem {
    idLien: number;
    libelle: string;
    url: string;
    icone: string;
    ordre: number;
    actif: boolean = true;
    remarque: string;

    getKey(): number | string {
        return this.idLien;
    }
}